import React from 'react';
import { Button, ButtonGroup, Label, Dropdown, DropdownToggle, Input, Alert, Modal, ModalHeader, ModalFooter, ModalBody, FormText, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withAlert } from 'react-alert';
import { CircularProgress } from '@mui/material';

class EmailDocumentModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            subject: '',
            message: '',
            pages: 'All',
            pageNumbers: 0,
            startPage: 0,
            endPage: 0,
            alert_message: '',
            alert_status: 0,
            loading: false
        }

    }

    emailDocument = () => {
        let pageNumbers = this.state.pageNumbers;

        if (this.state.pages == 'range')
            pageNumbers = this.state.startPage + ',' + this.state.endPage;

        this.setState({
            loading: true,
            alert_message: '',
            alert_status: 0,
        })

        fetch(window.location.protocol + '//' + window.location.host + "/api/email/send_email_with_attachment", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ document: this.props.file, subject: this.state.subject, to_address: this.state.email, message: this.state.message, pages: this.state.pages, pageNumbers: pageNumbers })
        })
            .then(res => res.json())
            .then(result => {
                if (result.error) {
                    this.setState({
                        loading: false,
                        alert_message: result.message,
                        alert_status: 404
                    })
                } else {
                    this.setState({
                        alert_message: result.message,
                        alert_status: 200
                    })

                    setTimeout(() => this.props.toggle(), 5000);
                }
            })
    }

    handleTextChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handlePageSelectChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render() {

        let groups = []
        let alert_message = {}

        if (this.state.alert_message)
            if (this.state.alert_status == 200)
                alert_message = <Alert color="success">
                    {this.state.alert_message}
                </Alert>
            else
                alert_message = <Alert color="danger">
                    {this.state.alert_message}
                </Alert>
        else
            alert_message = <div />

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>
                    Email File: {this.props.document}
                    <br />
                </ModalHeader>
                <ModalBody>
                    <Label for="email">To Address</Label>
                    <Input type="text" name="email" onChange={this.handleTextChange} />
                    <Label for="subject">Subject</Label>
                    <Input type="text" name="subject" onChange={this.handleTextChange} />
                    <Label for="pages">Pages</Label>
                    <Input type="select" name="pages" onChange={this.handlePageSelectChange}>
                        <option value="all">All</option>
                        <option value="number">Page Numbers</option>
                        <option value="range">Page Range</option>
                    </Input>
                    {this.state.pages == 'number' &&
                        <>
                            <Label for="pageNumbers">Page Numbers</Label>
                            <Input type="text" name="pageNumbers" onChange={this.handleTextChange} />
                            <FormText color="muted">
                                Seperate page numbers with comma ','
                            </FormText>
                        </>
                    }
                    {this.state.pages == 'range' &&
                        <Row>
                            <Col sm={5}>
                                <Label for="pageNumbers">Start Page</Label>
                                <Input type="Number" name="startPage" onChange={this.handleTextChange} />
                            </Col>
                            <Col sm={5}>
                                <Label for="pageNumbers">End Page</Label>
                                <Input type="Number" name="endPage" onChange={this.handleTextChange} />
                            </Col>
                        </Row>
                    }
                    <Label for="message">Message</Label>
                    <Input type="textarea" name="message" onChange={this.handleTextChange} />
                    <br />
                    {alert_message}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={this.emailDocument}
                        disabled={this.state.loading}>
                        {this.state.loading ?
                            <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
                            :
                            "Send"
                        }
                    </Button>
                    <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default withAlert()(EmailDocumentModal);